(function() {
  var gridEl = document.getElementById('cg-grid');
  if (!gridEl) return;

  /* ── Multi-page loader ──────────────────────────────────────────────
     Liquid renders up to 250 products per page (Shopify paginate cap).
     If the collection spans more pages, fetch the rest via the Section
     Rendering API and append the cards BEFORE initialising filters, so
     search / sort / facet counts always cover the full catalog. */
  function initWhenReady() {
    var totalPages = parseInt(gridEl.dataset.pages, 10) || 1;
    var currentPage = parseInt(gridEl.dataset.currentPage, 10) || 1;
    if (totalPages <= 1 || currentPage !== 1) { finishLoad(); return; }

    var next = 2;
    function fetchNext() {
      if (next > totalPages) { finishLoad(); return; }
      var url = location.pathname + '?page=' + next + '&section_id=collection-grid';
      fetch(url, { credentials: 'same-origin' })
        .then(function(r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function(html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          doc.querySelectorAll('#cg-grid .cg-item').forEach(function(el) {
            gridEl.appendChild(document.importNode(el, true));
          });
          next++;
          fetchNext();
        })
        .catch(function() { finishLoad(); }); /* init with what we have */
    }
    fetchNext();
  }

  function finishLoad() {
    var ls = document.getElementById('cg-loadstate');
    if (ls) ls.remove();
    init();
  }

  /* ── Filter / sort engine (runs once, after all pages are in) ────── */
  function init() {
  var searchEl  = document.getElementById('cg-search');
  var instockEl = document.getElementById('cg-instock');
  var sortEl    = document.getElementById('cg-sort');
  var grid      = document.getElementById('cg-grid');
  var noRes     = document.getElementById('cg-noresults');
  var countEl   = document.getElementById('cg-count');
  var panel     = document.getElementById('cg-filter-panel');
  var fbtn      = document.getElementById('cg-filter-btn');
  var fbadge    = document.getElementById('cg-filter-badge');
  var clearBtn  = document.getElementById('cg-filter-clear');
  var applyBtn  = document.getElementById('cg-filter-apply');
  var applyCnt  = document.getElementById('cg-fp-applycount');
  var priceMinEl  = document.getElementById('cg-price-min');
  var priceMaxEl  = document.getElementById('cg-price-max');
  var priceMinVal = document.getElementById('cg-price-min-val');
  var priceMaxVal = document.getElementById('cg-price-max-val');
  var priceRange  = document.getElementById('cg-price-range');
  var gMinSel = document.getElementById('cg-grade-min');
  var gMaxSel = document.getElementById('cg-grade-max');
  if (!searchEl || !grid) return;
  var items = Array.from(grid.querySelectorAll('.cg-item'));
  var groups = { language:'language', era:'era', condition:'condition', rarity:'rarity', finish:'finish', set:'set', graded:'graded', gradingco:'gradingco' };
  function distinctValues(dataKey) { var counts={}; items.forEach(function(el){ var v=(el.dataset[dataKey]||'').trim(); if(v) counts[v]=(counts[v]||0)+1; }); return counts; }
  Object.keys(groups).forEach(function(fkey){
    var dataKey=groups[fkey]; var counts=distinctValues(dataKey); var values=Object.keys(counts);
    var groupEl=panel?panel.querySelector('.cg-fgroup[data-fkey="'+fkey+'"]'):null; if(!groupEl) return;
    if(values.length<2){ groupEl.remove(); return; }
    groupEl.hidden=false; values.sort(function(a,b){return a.localeCompare(b);});
    var container=groupEl.querySelector('.cg-checks');
    container.innerHTML=values.map(function(v){ var safe=v.replace(/\"/g,'&quot;'); return '<label class="cg-check"><input type="checkbox" data-fkey="'+fkey+'" value="'+safe+'"><span class="box"></span><span class="cg-opt-text">'+v+'</span><span class="cg-opt-count">'+counts[v]+'</span></label>'; }).join('');
  });
  var gradeGroupEl=panel?panel.querySelector('.cg-fgroup[data-fkey="graderange"]'):null;
  var gradeVals=[];
  items.forEach(function(el){ var g=parseFloat(el.dataset.gradenum); if(!isNaN(g)&&gradeVals.indexOf(g)===-1) gradeVals.push(g); });
  if(gradeGroupEl){
    if(gradeVals.length<1){ gradeGroupEl.remove(); gradeGroupEl=null; }
    else {
      gradeGroupEl.hidden=false; gradeVals.sort(function(a,b){return a-b;});
      var optHtml=gradeVals.map(function(g){ var lbl=(g%1===0)?g.toFixed(0):g.toString(); return '<option value="'+g+'">'+lbl+'</option>'; }).join('');
      gMinSel.innerHTML=optHtml; gMaxSel.innerHTML=optHtml; gMinSel.value=gradeVals[0]; gMaxSel.value=gradeVals[gradeVals.length-1];
    }
  }
  var allPrices=items.map(function(el){return parseFloat(el.dataset.price)||0;});
  var globalMin=Math.floor(Math.min.apply(null,allPrices));
  var globalMax=Math.ceil(Math.max.apply(null,allPrices));
  if(globalMin===globalMax){ globalMax=globalMin+1; }
  priceMinEl.min=globalMin; priceMinEl.max=globalMax; priceMinEl.value=globalMin;
  priceMaxEl.min=globalMin; priceMaxEl.max=globalMax; priceMaxEl.value=globalMax;
  function formatPrice(v){ return '$'+parseFloat(v).toFixed(2); }
  function updateSliderUI(){ var minV=parseFloat(priceMinEl.value),maxV=parseFloat(priceMaxEl.value); var range=globalMax-globalMin; priceRange.style.left=((minV-globalMin)/range*100)+'%'; priceRange.style.width=((maxV-minV)/range*100)+'%'; priceMinVal.textContent=formatPrice(minV); priceMaxVal.textContent=formatPrice(maxV); }
  updateSliderUI();
  if(panel){ panel.querySelectorAll('.cg-fgroup-head').forEach(function(head){ head.addEventListener('click',function(){ var open=head.getAttribute('aria-expanded')==='true'; head.setAttribute('aria-expanded',open?'false':'true'); }); }); }
  function getSelections(){ var sel={}; if(panel){ panel.querySelectorAll('.cg-checks input:checked').forEach(function(cb){ var k=cb.dataset.fkey; (sel[k]=sel[k]||[]).push(cb.value.toLowerCase()); }); } return sel; }
  function activeFilterCount(){ var n=0; if(panel) n+=panel.querySelectorAll('.cg-checks input:checked').length; if(parseFloat(priceMinEl.value)>globalMin||parseFloat(priceMaxEl.value)<globalMax) n++; if(gradeGroupEl){ if(parseFloat(gMinSel.value)>gradeVals[0]||parseFloat(gMaxSel.value)<gradeVals[gradeVals.length-1]) n++; } return n; }
  function matches(item){
    var stock=parseInt(item.dataset.stock,10)||0; if(instockEl.checked&&stock<=0) return false;
    var q=searchEl.value.trim().toLowerCase();
    if(q){ var hay=(item.dataset.title||'')+' '+(item.dataset.tags||'')+' '+(item.dataset.type||'')+' '+(item.dataset.vendor||'')+' '+(item.dataset.set||'').toLowerCase()+' '+(item.dataset.rarity||'').toLowerCase(); if(hay.indexOf(q)===-1) return false; }
    var price=parseFloat(item.dataset.price)||0; if(price<parseFloat(priceMinEl.value)||price>parseFloat(priceMaxEl.value)) return false;
    if(gradeGroupEl){ var gmin=parseFloat(gMinSel.value),gmax=parseFloat(gMaxSel.value); var usingGrade=(gmin>gradeVals[0]||gmax<gradeVals[gradeVals.length-1]); if(usingGrade){ var gv=parseFloat(item.dataset.gradenum); if(isNaN(gv)||gv<gmin||gv>gmax) return false; } }
    var sel=getSelections();
    for(var fkey in sel){ if(!sel.hasOwnProperty(fkey)) continue; var want=sel[fkey]; if(!want.length) continue; var have=(item.dataset[groups[fkey]]||'').trim().toLowerCase(); if(want.indexOf(have)===-1) return false; }
    return true;
  }
  function countMatches(){ var n=0; items.forEach(function(it){ if(matches(it)) n++; }); return n; }
  var timer;
  function applyFilter(){
    clearTimeout(timer);
    if(instockEl.checked) grid.classList.add('cg-instock-active'); else grid.classList.remove('cg-instock-active');
    timer=setTimeout(function(){
      var vis=0;
      items.forEach(function(it){ var ok=matches(it); it.style.display=ok?'':'none'; if(ok) vis++; });
      countEl.textContent=vis+' item'+(vis===1?'':'s');
      if(noRes) noRes.style.display=vis===0?'block':'none';
      var fc=activeFilterCount();
      if(fc>0){ fbadge.hidden=false; fbadge.textContent=fc; } else fbadge.hidden=true;
    },120);
  }
  function refreshApplyCount(){ if(applyCnt) applyCnt.textContent=countMatches(); }
  searchEl.addEventListener('input',applyFilter);
  instockEl.addEventListener('change',applyFilter);
  priceMinEl.addEventListener('input',function(){ if(parseFloat(priceMinEl.value)>parseFloat(priceMaxEl.value)) priceMinEl.value=priceMaxEl.value; updateSliderUI(); refreshApplyCount(); });
  priceMaxEl.addEventListener('input',function(){ if(parseFloat(priceMaxEl.value)<parseFloat(priceMinEl.value)) priceMaxEl.value=priceMinEl.value; updateSliderUI(); refreshApplyCount(); });
  if(gradeGroupEl){ gMinSel.addEventListener('change',function(){ if(parseFloat(gMinSel.value)>parseFloat(gMaxSel.value)) gMaxSel.value=gMinSel.value; refreshApplyCount(); }); gMaxSel.addEventListener('change',function(){ if(parseFloat(gMaxSel.value)<parseFloat(gMinSel.value)) gMinSel.value=gMaxSel.value; refreshApplyCount(); }); }
  if(panel){ panel.querySelectorAll('.cg-checks input').forEach(function(cb){ cb.addEventListener('change',refreshApplyCount); }); }
  if(fbtn&&panel){ fbtn.addEventListener('click',function(){ var open=fbtn.getAttribute('aria-expanded')==='true'; fbtn.setAttribute('aria-expanded',open?'false':'true'); panel.hidden=open; if(!open) refreshApplyCount(); }); }
  if(applyBtn){ applyBtn.addEventListener('click',function(){ applyFilter(); fbtn.setAttribute('aria-expanded','false'); panel.hidden=true; }); }
  if(clearBtn){ clearBtn.addEventListener('click',function(){ panel.querySelectorAll('.cg-checks input:checked').forEach(function(cb){ cb.checked=false; }); priceMinEl.value=globalMin; priceMaxEl.value=globalMax; updateSliderUI(); if(gradeGroupEl){ gMinSel.value=gradeVals[0]; gMaxSel.value=gradeVals[gradeVals.length-1]; } refreshApplyCount(); applyFilter(); }); }
  function applySort(){
    var mode=sortEl?sortEl.value:'number';
    var sorted=items.slice().sort(function(a,b){
      if(mode==='number'){ var na=parseInt(a.dataset.number,10),nb=parseInt(b.dataset.number,10); if(isNaN(na)) na=999999; if(isNaN(nb)) nb=999999; return na-nb; }
      else if(mode==='alpha'){ return (a.dataset.title||'').localeCompare(b.dataset.title||''); }
      else if(mode==='price-asc'){ return parseFloat(a.dataset.price)-parseFloat(b.dataset.price); }
      else if(mode==='price-desc'){ return parseFloat(b.dataset.price)-parseFloat(a.dataset.price); }
      else if(mode==='grade-desc'){ var ga=parseFloat(a.dataset.gradenum),gb=parseFloat(b.dataset.gradenum); if(isNaN(ga)) ga=-1; if(isNaN(gb)) gb=-1; return gb-ga; }
      return 0;
    });
    sorted.forEach(function(el){ grid.appendChild(el); });
  }
  if(sortEl) sortEl.addEventListener('change',function(){ applySort(); applyFilter(); });
  grid.classList.add('cg-instock-active');
  applySort(); applyFilter(); refreshApplyCount();
  }

  initWhenReady();
})();
